import infoModal from '../InfoModal'
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react'
import './UserProfile.css'
import Avatar from '../Avatar/Avatar'
import Icon from '../Icon2'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { Truncate } from '../Truncate/Truncate'

import Line from '../Line/Line';
import Dropdown from '../DropDown/Dropdown';

type UserProfileProps = {
  orgName: string
  list: ListType
  type: AvatarType
  avatar: AvatarData
  handleEvent: (e: any) => void
  testId?: string
  closeModal?: (e: any) => void
  orgBannerImageUrl?: string | undefined
  onImageSelect?: (e: any) => void
  isOwner?: boolean,
  appendOrgBannerCover?: any
  planName?: string
  showUpgradeBadge?: boolean
  onBadgeClick?: (e: any) => void
}

type ListItem = {
  icon?: string
  text?: string
  toggle?: ToggleData
  iconVersion?: string
  id: string,
  dropdown?: boolean,
  orgData?: OrgData[],
}

type OrgData = {
  label: React.JSX.Element,
  value: string,
  action: () => void
};

type ListType = ListItem[]

type AvatarType = 'text' | 'image'

type AvatarData = {
  image?: string
  name: string
  email: string
}

type ToggleData = {
  checked: boolean
}

function displayAvatarContent(type, avatar) {
  if (type === 'image') {
    return <img src={avatar.image} alt={avatar.name} className="Avatar__imagee" />
  }
  let nameInitials = avatar && avatar.name && avatar.name.split(' ')
  let firstInitial = (nameInitials && nameInitials[0]) || ''
  let lastInitial = (nameInitials && nameInitials[nameInitials?.length - 1]) || ''
  let nameInitialsShort =
    nameInitials && nameInitials.length === 1
      ? nameInitials[0]
      : firstInitial?.substring(0, 1) + lastInitial?.substring(0, 1)
  return nameInitialsShort
}

const UserAvatar = ({ type, avatar }) => {
  return (
    <div className="Avatar--pic" tabIndex={0} aria-label='User Avatar' id='userprofile-avatar-pic'>
      <span className="Avatar__link">{displayAvatarContent(type, avatar)}</span>
    </div>
  )
}

const Options = ({ list, handleEvent, closeModal, orgName }) => {
  return (
    <div className="options">
      {list.map((item, key) => {
        if (item?.dropdown) {
          return <div className='organization_body'>
            <Line type='solid' width={284} />
            <div className='switch_organization' aria-label='Switch Organization'>
              <p>Switch organization</p>
            </div>
            <div title={orgName}>
              <Dropdown
                type='select'
                list={item.orgData || []}
                version='v2'
                closeAfterSelect={true}
                withIcon={true}
                onChange={(e) => {
                  closeModal();
                }}
                withSearch={item.showOrgSearch}
                emptyPlaceholder={orgName}
                dropdownChevronIcon='CaretRight'
                testId='cs-userprofile-orgdropdown'
              ></Dropdown>
            </div>
            <Line type='solid' width={284} />
          </div>
        } else {
          return <label
            key={key}
            onClick={
              (e) => {
                handleEvent(e)
                if (!item?.toggle) {
                  closeModal()
                }
              }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleEvent(e);
                e.currentTarget.click();
                if (!item?.toggle) {
                  closeModal()
                }
              }
            }}
            className={`list-option ${item?.toggle ? 'switch-option' : ''}`}
            id={!item?.toggle ? item?.id || "" : ""}
            data-test-id='cs-userprofile-click'
            tabIndex={0}
            aria-label={item?.text}
          >
            <Icon icon={item.icon} version={item.iconVersion || 'v2'} size="medium" />
            {item?.text}
            {item?.toggle && <ToggleSwitch id={item.id} defaultChecked={item.toggle?.checked} testId={item.toggle.testId} name={'Toggle Switch'} skipTab={true} />}
          </label>
        }
      })
      }
    </div >
  )
}

const MyComponent = ({
  orgName,
  list,
  type,
  avatar,
  handleEvent,
  closeModal,
  orgBannerCover,
  onImageSelect,
  isOwner,
  planName,
  showUpgradeBadge,
  onBadgeClick
}: any) => {
  //   const [orgBannerCover, setOrgBannerCover] = useState(orgBannerImageUrl)
  // useEffect(() => {
  //   console.log('orgBannerImageUrl called in useEff ==> ', orgBannerImageUrl)
  //   setOrgBannerCover(orgBannerImageUrl)
  // }, [orgBannerImageUrl])

  console.log('orgBannerImageUrl called ==> ', orgBannerCover)
  const appendOrgBannerCover = orgBannerCover ? {
    backgroundImage: `url(${orgBannerCover})`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  } : {}
  const fileRef = useRef(null);

  const simulateUpload = () => {
    console.log('upload', fileRef)
    fileRef.current.click();
  }

  return (
    <div 
      className="UserProfile" 
      id='UserProfile'
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          const clickEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          e.currentTarget.dispatchEvent(clickEvent);
          closeModal();
        } 
      }}
    >
      <div className="org" style={appendOrgBannerCover}>
        {isOwner && <div className='hover-overlay'>
          <Icon
            id="editOrgBanner"
            onClick={
              simulateUpload
            }
            className="editOrgBanner"
            icon={'Edit'}
            version="v2"
            size="small"
          />
          <p
            onClick={simulateUpload}
            data-test-id='cs-userprofile-simulateupload'
          >Edit Organisation Image</p>
          <input
            type="file"
            id="replace-file-input"
            name="asset"
            onChange={(e) => onImageSelect(e)}
            ref={fileRef}
            multiple={false}
            accept="image/*"
            style={{ display: 'none' }}
            data-test-id="cs-userprofile-replacefileinput"
          />
        </div>}

      </div>
      <div className="user-info">
        <UserAvatar type={type} avatar={avatar} />
        <div className="email" tabIndex={0} aria-label={`User Email ${avatar.email}`}>
          <Truncate maxChar={30}>{avatar.email}</Truncate>
        </div>
        <div className="name" tabIndex={0} aria-label={`User Name ${avatar.name}`}>
          <Truncate>{avatar.name}</Truncate>
        </div>
      </div>
      {planName &&
        (showUpgradeBadge ? (
          <div className="free-plan-section" data-test-id="cs-userprofile-free-plan">
            <div className="free-plan-section__pill">
              <span className="free-plan-section__label">
                {planName}
              </span>
              <button
                type="button"
                className="free-plan-section__upgrade"
                aria-label="Upgrade your plan"
                data-test-id="cs-userprofile-upgrade"
                onClick={() => {
                  if (onBadgeClick) onBadgeClick()
                  if (closeModal) closeModal()
                }}>
                <Icon icon="SuperUser" version="v2" size="tiny" />
                <span className="free-plan-section__upgrade-label">Upgrade</span>
              </button>
            </div>
          </div>
        ) : (
          <div className="plan-section" data-test-id="cs-userprofile-plan-section">
            <div className="plan-section__pill">
              <span className="free-plan-section__label">
                {planName}
              </span>
            </div>
          </div>
        ))}
      <Options list={list} handleEvent={handleEvent} closeModal={closeModal} orgName={orgName} />
    </div>
  )
}

function getFocusableElements(container: HTMLElement | null): HTMLElement[] {
  if (!container) return []
  return Array.from(container.querySelectorAll<HTMLElement>('*')).filter(
    (el) => el.tabIndex >= 0 && !el.hasAttribute('disabled')
  )
}

const UserProfile = forwardRef(
  (
    {
      orgName,
      list,
      type,
      avatar,
      handleEvent,
      testId = 'user-profile',
      orgBannerImageUrl,
      onImageSelect,
      isOwner,
      planName,
      showUpgradeBadge,
      onBadgeClick
    }: UserProfileProps,
    ref
  ) => {
    const targetRef = useRef(null)
    const portalRef = useRef(null)
    let [isModalOpen, setIsModalOpen] = useState(false)
    const didMount = useRef(false)

  const [orgBannerCover, setOrgBannerCover] = useState(orgBannerImageUrl)
  useEffect(() => {
    console.log('orgBannerImageUrl called in useEff ==> ', orgBannerImageUrl)
    setOrgBannerCover(orgBannerImageUrl)
    onClose()
  }, [orgBannerImageUrl])

  const onClose = () => {
    setIsModalOpen(false)
    if (didMount.current) {
      portalRef.current?.focus();
    }
  }
  const reopenModal = () => {
    console.log("Re Open Modal");
    targetRef?.current.click()
  }

  useImperativeHandle(ref, () => ({
    callInternalMethod: () => reopenModal()
  }));

  const handleClick = () => {
    if (!isModalOpen) {
      infoModal({
        component: (props) => {
          useEffect(() => {
            // When modal mounts, put focus on the first element
            document.getElementById("userprofile-avatar-pic")?.focus();
          }, []);

          useEffect(() => {
            didMount.current = true;
          }, []);          

          useEffect(() => {
            const handleKeyDown = (e: KeyboardEvent) => {
              if (e.key !== "Tab") return;
          
              const focusables = getFocusableElements(document.getElementById("UserProfile"));
              if (focusables.length === 0) return;
          
              const first = focusables[0];
              const last = focusables[focusables.length - 1];
          
              if (e.shiftKey) {
                // shift+tab on first element
                if (document.activeElement === first) {
                  e.preventDefault();
                  onClose();
                  props.closeModal();
                  portalRef.current?.focus(); // back to avatar
                }
              } else {
                // tab on last element
                if (document.activeElement === last) {
                  e.preventDefault();
                  onClose();
                  props.closeModal();
                  portalRef.current?.focus(); // back to avatar
                }
              }
            };
          
            document.addEventListener("keydown", handleKeyDown);
            return () => document.removeEventListener("keydown", handleKeyDown);
          });

          return <MyComponent {...{ orgName, list, type, avatar, handleEvent, closeModal: props.closeModal, orgBannerCover, onImageSelect, isOwner, planName, showUpgradeBadge, onBadgeClick }} />
        },
        modalProps: {
          onClose,
          targetNodeOrId: targetRef.current,
          closeOnOverlayClick: true,
          ignoreContainers: ['parentid'],
          portal: {
            sourceElem: portalRef.current,
            AdjustLeftOffset: -270,
            AdjustTopOffset: 5
          }
        }
      })
      setIsModalOpen(true)
    }
  }

  return (
    <div ref={targetRef} data-test-id={testId}>
      <label ref={portalRef} 
        onClick={handleClick} 
        className='user-profile-tab-index' 
        tabIndex={0}
        aria-label="User Profile"
        aria-expanded={isModalOpen}
        role='button'
        aria-controls='true'
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (didMount.current) {
              const clickEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              e.currentTarget.dispatchEvent(clickEvent);        
            } else {
              handleClick();
            }
          } else if (e.key === "Escape") {
            if (didMount.current) {
              const clickEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              e.currentTarget.dispatchEvent(clickEvent);   
              setIsModalOpen(false)
            }
          }
        }}
      >
        <Avatar
          type={type}
          avatars={[{ name: avatar.name, email: avatar.email, id: 1, image: avatar.image, avatarColor: '' }]}
        />
      </label>
    </div>
  )
});
UserProfile.displayName = 'UserProfile';
export default UserProfile